import { dmApi } from "../../../app/dmApi";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/RtkQueryUtils";
import { serialize } from "../../../helpers/Utils";
export const materialApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        createBrokerageRefrigeration: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/brokerage-data/refrigeration/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['brokerageRefrigeration', 'brokerageSummary', 'getRefrigerationPallets'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Data")

            },

        }),
        createBrokerageMaterial: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/brokerage-data/material/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['material', 'materialById', 'brokerageSummary', 'brokerageBarChart', 'brokerageSortingChart','brokerageSortAndPackedSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Data")

            },

        }),
        createBrokeragePackingMaterial: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/brokerage-data/packing/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['packing', 'brokerageSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Data")

            },

        }),
        createBrokerageBoxesData: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/brokerage-data/boxes/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['boxesPacked', 'brokerageSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Data")

            },

        }),
        createBrokerageEmployee: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/brokerage-data/emp-data/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['brokerageEmployee', 'brokerageSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Data")

            },

        }),
        getBrokerageRefrigerationData: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/brokerage-data/refrigeration?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['brokerageRefrigeration'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getBrokerageBarChartData: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/brokerage-data/bar-chart-data?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['brokerageBarChart'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getBrokerageSortingChartData: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/brokerage-data/sorting-chart-data?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['brokerageSortingChart'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getBrokerageMetricsChartData: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/brokerage-data/metric-chart-data?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['brokerageMetricsChart'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getBrokeragePackingChart: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/brokerage-data/packing-chart-data?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['brokeragePackingChart'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getBrokerageEmployee: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/brokerage-data/emp-data/logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['brokerageEmployee'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getBrokerageMaterial: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/brokerage-data/material?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['material'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getBrokerageBoxesPackedData: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/brokerage-data/boxes?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['boxesPacked'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getBrokeragePackingData: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/brokerage-data/packing?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['packing'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getBrokerageSummary: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/brokerage-data/summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['brokerageSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getMaterialEnteredSummary: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url:`/brokerage-data/material/get-summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['brokerageSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getRefrigerationSummary: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url:`/brokerage-data/refrigeration/summary-overview?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['refrigerationSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getBrokerageSortAndPackedSummary: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/brokerage-data/sort-and-packed-summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['brokerageSortAndPackedSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        updateBrokerageMaterial: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/brokerage-data/material/update/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['material', 'materialById', 'brokerageSummary', 'brokerageBarChart', 'brokerageSortingChart','brokerageSortAndPackedSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Data")
            },
        }),
        updateBrokerageRefrigeration: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/brokerage-data/refrigeration/update/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['brokerageRefrigeration', 'brokerageSummary', 'getRefrigerationPallets'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Data")
            },
        }),
        updateBrokerageEmployee: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/brokerage-data/emp-data/update/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['brokerageEmployee', 'brokerageSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Data")
            },
        }),
        updateBrokeragePacking: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/brokerage-data/packing/update/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['packing', 'brokerageSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Data")
            },
        }),
        updateBrokerageBoxesPacked: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/brokerage-data/boxes/update/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['boxesPacked', 'brokerageSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Data")
            },
        }),
        sortAndPackedBrokerageData: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/brokerage-data/sort-and-packed/${id}`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['material', 'packing', 'boxesPacked', 'brokerageSummary', 'brokerageSortAndPackedSummary', 'brokerageBarChart', 'brokerageSortingChart', 'brokeragePackingChart'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled,  "Sorting & Packing Data" ,"Updated")
            },
        }),
        getBrokerageMaterialById: build.query({
            query: (id) => {
                return {
                    url: `/brokerage-data/material/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['materialById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getBrokeragePackingMaterialById: build.query({
            query: (id) => {
                return {
                    url: `/brokerage-data/packing/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['packingById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getBrokerageRefrigerationDataBYId: build.query({
            query: (id) => {
                return {
                    url: `/brokerage-data/refrigeration/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['brokerageRefrigerationById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getBrokeragePalletRecords: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/brokerage-data/refrigeration/get-pallet-record?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['brokeragePalletRecords'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getBrokerageBoxPackedById: build.query({
            query: (id) => {
                return {
                    url: `/brokerage-data/boxes/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['boxesboxesPacked'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getBrokeragePackingBandRecord: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/brokerage-data/packing-band/record?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['brokeragePackingBandRecord'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        createBrokeragePackingBandRecord: build.mutation({
            query: (requestBody) => ({
                url: `/brokerage-data/packing-band/create`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['brokeragePackingBandRecord'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Packing Band Record");
            },
        }),

        updateBrokeragePackingBandRecord: build.mutation({
            query: ({ id, requestBody }) => ({
                url: `/brokerage-data/packing-band/update/${id}`,
                method: 'PUT',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['brokeragePackingBandRecord'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Packing Band Record");
            },
        }),

        getBrokerageSeparationRecord: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/brokerage-data/separation/record?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['brokerageSeparationRecord'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        createBrokerageSeparationRecord: build.mutation({
            query: (requestBody) => ({
                url: `/brokerage-data/separation/create`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['brokerageSeparationRecord'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Separation Record");
            },
        }),

        updateBrokerageSeparationRecord: build.mutation({
            query: ({ id, requestBody }) => ({
                url: `/brokerage-data/separation/update/${id}`,
                method: 'PUT',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['brokerageSeparationRecord'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Separation Record");
            },
        }),

        updateRefrigerationPendingKg: build.mutation({
            query: (requestBody) => ({
                url: `/packing-data/refrigeration-data/pending-kg/update`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['refrigerationSummary'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Pending KG");
            },
        }),
    }),
});

export const {
    useCreateBrokerageMaterialMutation,
    useGetBrokerageMaterialQuery,
    useUpdateBrokerageMaterialMutation,
    useGetBrokerageMaterialByIdQuery,
    useGetBrokerageSummaryQuery,
    useGetRefrigerationSummaryQuery,
    useGetMaterialEnteredSummaryQuery,
    useGetBrokerageSortAndPackedSummaryQuery,
    useGetBrokeragePackingDataQuery,
    useCreateBrokeragePackingMaterialMutation,
    useUpdateBrokeragePackingMutation,
    useLazyGetBrokeragePackingMaterialByIdQuery,
    useCreateBrokerageBoxesDataMutation,
    useGetBrokerageBoxesPackedDataQuery,
    useUpdateBrokerageBoxesPackedMutation,
    useGetBrokerageBoxPackedByIdQuery,
    useCreateBrokerageEmployeeMutation,
    useGetBrokerageEmployeeQuery,
    useUpdateBrokerageEmployeeMutation,
    useCreateBrokerageRefrigerationMutation,
    useGetBrokerageRefrigerationDataQuery,
    useUpdateBrokerageRefrigerationMutation,
    useGetBrokerageRefrigerationDataBYIdQuery,
    useGetBrokerageBarChartDataQuery,
    useGetBrokerageSortingChartDataQuery,
    useGetBrokeragePackingChartQuery,
    useGetBrokerageMetricsChartDataQuery,
    useSortAndPackedBrokerageDataMutation,
    useLazyGetBrokeragePalletRecordsQuery,
    useGetBrokeragePackingBandRecordQuery,
    useCreateBrokeragePackingBandRecordMutation,
    useUpdateBrokeragePackingBandRecordMutation,
    useGetBrokerageSeparationRecordQuery,
    useCreateBrokerageSeparationRecordMutation,
    useUpdateBrokerageSeparationRecordMutation,
    useUpdateRefrigerationPendingKgMutation,
} = materialApi;